/* eslint-disable prefer-template */
import React, { useEffect } from "react";
import { MetadataForm } from '@jutro/legacy/uiconfig';
import { useTranslator } from "@jutro/locale";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { WMICSidebarBoxes } from "gw-portals-wizard-components-ui";
import { publish } from '@jutro/events';
import { WMICTopics } from 'wmic-portals-utils-js';
// NEW: Import error tracking for Adobe Analytics (INS document requirement)
import { setError, ERROR_REASONS } from '../../../../../quote-and-buy/src/utils/dataLayer';
import appConfig from 'app-config';

import metadata from "./WMICPolicyInProcessPage.metadata.json5";
import messages from "./WMICPolicyInProcessPage.messages";
import styles from "./WMICPolicyInProcessPage.module.scss";

function WMICPolicyInProgress(props) {
    const { location } = props;
    const translator = useTranslator();
    const quoteID = new URLSearchParams(location.search).get('quoteID')
    const { phoneNumber } = appConfig;
    
    // NEW: Track policy in process error for Adobe Analytics (INS document page 42)
    useEffect(() => {
        // Set error in data layer with INS format: "sorry applicationerror-policy in process"
        setError(ERROR_REASONS.POLICY_IN_PROCESS, 'sorry applicationerror');
        
        // Track policy in process page for Adobe Analytics
        publish(WMICTopics.ROUTE_CHANGED, {
            page: 'insurance:renters:quote:sorry applicationerror',
            subchannel2: 'quote',
            ins_quoteid: quoteID,
            ins_quote_id: quoteID ? 'IQQ' + quoteID : ''
        });
        
        // Track error event
        publish(WMICTopics.FORM_ERROR, {
            error: 'policy in process',
            error_message: 'Policy is currently being processed',
            page: 'insurance:renters:quote:sorry applicationerror',
            ins_quoteid: quoteID
        });
        
        // Fire analytics with updated data layer
        if (window.utag && window.utag.view) {
            window.utag.view(window.wins_data_layer);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const overrideProps = {
        confirmationOfPurchase: {
            content: translator(messages.confirmationOfPurchase)
        },
        confirmationMessage: {
            content: `${translator(messages.thankYou)} ${translator(messages.contactUs, { phoneNumber })
            }`
        },
        quoteNumber: {
            content: `${translator(messages.quoteNumber, {
                quoteNumber: quoteID
            })}`
        },
        callCenterHours: {
            content: translator(messages.callCenterHours)
        },
        weekdayHours: {
            content: translator(messages.weekdayHours)
        },
        weekendHours: {
            content: translator(messages.weekendHours)
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            wmicSidebarBoxes: WMICSidebarBoxes
        }
    };

    return (
        <MetadataForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap} />
    );
}

WMICPolicyInProgress.propTypes = {
    location: PropTypes.shape({
        search: PropTypes.string.isRequired
    })
};
WMICPolicyInProgress.defaultProps = {
    location: undefined
};
export default withRouter(WMICPolicyInProgress);
